<template>
    <v-form ref="form" v-model="valid" style="height: 850px;">
        <v-card class="overflow-x-hidden system_dialog_color system_admin_font_family_primary ">
            <v-card-title class="pa-3 pl-3 pb-0 border-bottom system_dialog_color pt-1 ">
                <span class="h5 system_dialog_font_color pl-4">Activity Details</span>
                <v-row class="m-0">
                    <v-col cols="pull-right-10 p-2 ">
                        <v-btn
                            text
                            icon
                            small
                            color="gray"
                            class="float-right "
                            @click="closeDialog()"
                        >
                         <span class="system_dialog_font_color">  <v-icon >mdi-close-circle</v-icon></span>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-text class="system_dialog_color">
                <v-container class="pb-0 mt-1" fluid>
                    <v-row no-gutters>
                        <v-col >
                            <v-btn
                                @click="triggerFileViewerDialog(true)"
                                class="float system_dialog_button_color"
                            >
                               <span class="system_dialog_font_color"><v-icon>
                                    mdi-folder-image
                                </v-icon></span> 
                            </v-btn>
                            <BaseFilesViewerVue :event_activity_images="form.event_activity_images" :rules="errors.required"/>
                            <FileUploadComponent  ref="fileUpload" :label="'Event Images'" @uploadedData="uploadedData" @reset="clearFileUpload" />
                        </v-col>
                        <v-col cols="12" class="pa-0 pb-2 system_dialog_text_color">
                            Event Activity Main Image
                            <v-hover v-model="isHover">
                                <template v-slot="{ hover }" >
                                    <v-card style="border: #444444 2px solid;height:75%">
                                        <v-container fluid class="picture">
                                            <v-img :src="form.activity_image" contain aspect-ratio="1.7">
                                            </v-img>
                                        </v-container>
                                        <v-fade-transition style="opacity:0.5;">
                                            <v-overlay absolute :color="hover ? 'white' : ''"  class="d-flex flex-row justify-content-center align-items-center">
                                                    <v-row>
                                                        <v-tooltip bottom color="#2590ff">
                                                            <template v-slot:activator="{ on, attrs }" >
                                                                <v-btn
                                                                    v-show="hover == true"
                                                                    v-on="on"
                                                                    v-bind="attrs"
                                                                    :disabled="disabled_view"
                                                                    style="opacity:1; cursor: pointer;"
                                                                    class="ma-2"
                                                                    color="#2590ff"
                                                                    text
                                                                >
                                                                    <label for="upload-file"><span class="upload-file system_dialog_font_color"><v-icon x-large>mdi-tray-arrow-up</v-icon></span></label>
                                                                </v-btn>
                                                            </template>
                                                            <span>Upload Image</span>
                                                        </v-tooltip>
                                                    </v-row>
                                                <input   class="d-none" id="upload-file" type="file" ref="fileInput" @change="uploadImage" accept="image/png, image/jpeg"/>
                                            </v-overlay>
                                        </v-fade-transition>
                                    </v-card>
                                </template>
                            </v-hover>
                       
                        <v-col cols="12" class="pt-5">
                            <v-text-field
                                v-model="form.name"
                                :disable="disabled_view"
                                label="Name"
                                class="system_dialog_text_color"
                                outlined
                                dense
                                required
                                :rules="errors.required"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" class="pt-2">
                            <v-textarea
                                v-model="form.description"
                                :disable="disabled_view"
                                counter="200"
                                :rules="errors.required"
                                required
                                label="Description"
                                class="system_dialog_text_color"
                                outlined
                                dense
                            >
                            </v-textarea>
                        </v-col>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-card-actions
                class="text-center system_dialog_color"
                style="border-top: 1px solid #000000"
                
            >
                <v-row class="ma-1 pb-2">
                    <v-col cols="12" v-if="actions != 'View'">
                        <v-btn
                            @click="
                                actions == 'Submit'? addRafflePrize() : updateRafflePrize()"
                            :disabled="disabled_view"
                            class="system_dialog_button_color"
                        >
                            <span class="system_dialog_text_color">{{ actions }}</span>
                        </v-btn>
                        <span class="pr-12">&nbsp;</span>
                    </v-col>
                </v-row>
            </v-card-actions>
        </v-card>
    </v-form>
</template>
<script>
import Swal from "sweetalert2";
import { mapGetters } from "vuex";
import FileUploadComponent from "@/components/shared/FileUploadComponent.vue"
import BaseFilesViewerVue from '@/components/shared/BaseFilesViewer.vue';
import { error } from "jquery";
export default {
    data() {
        return {
            valid: false,
            overlay: false,
            disabled_view: false,
            form: {},
            isHover: false,
            errors: {
                required: [v => !!v || 'The field is required.'],
                name: [v => !!v || 'The name is required'],
                description: [v => !!v || 'The description is required'],
            },
            isMultiple: false,
            nameRules: [(v) => !!v || 'The Name is required.'],
            descriptionRules: [(v) => !!v || 'The Description is required.'],
        };
    },
    components:{
        FileUploadComponent,
        BaseFilesViewerVue
    },
    computed: {
        ...mapGetters([
            "ACTION",
            "DIALOGS",
            "GET_DIALOG_VIEW",
            "GET_EVENT_ID"
        ]),
        actions() {
            if (this.ACTION == "Submit") {
                this.disabled_view = false;
                this.isViewBtn = false;
                return "Submit";
            } else if (this.ACTION == "Update") {
                this.disabled_view = false;
                this.isViewBtn = true;
                this.getActivityData();
                return "Update";
            } else if (this.ACTION == "View") {
                this.disabled_view = true;
                this.isViewBtn = true;
                this.getActivityData();
                return "View";
            }
        },
    },
    created() {
        this.initialForm();
    },
    mounted() {
    },
    methods: {
        initialForm() {
            this.form = {
                code        : '',
                name        : '',
                order       : '',
                activity_image : '',
                event_activity_images: [],
            };
            // this.$refs.fileInput.value = null;
            this.clearFileUpload();
        },
        height(width) {
            switch (this.$vuetify.breakpoint.name) {
                case "xs":
                    return "100%";
                case "sm":
                    return "100%";
                case "md":
                    return width;
                case "lg":
                    return width;
                case "xl":
                    return width;
            }
        },
        closeDialog() {
            this.$store.commit("DIALOG", false);
        },
        async addRafflePrize() {
            this.$refs.form.validate();
            let name_swal_text = this.form.name ? '' : 'name';
            let description_swal_text = this.form.description ? '' : 'description';
            let file_swal_text = '';
            const file = this.$refs.fileInput.files[0];
            if (!file) {
                file_swal_text = 'Event Image';
            } else if (!['image/png', 'image/jpeg'].includes(file.type)) {
                file_swal_text = 'Valid Image (PNG or JPEG)';
            } else if (file.size > 2 * 1024 * 1024) {
                file_swal_text = 'Image below 2 MB';
            }
            let array_text =
            [
                name_swal_text,
                description_swal_text,
                file_swal_text
            ]
            let filtered = array_text.filter((el) => el).join(', ');
            if (
                this.form.name &&
                this.form.description &&
                !file_swal_text
            ) {
                let payload = {
                    url: "eventActivities",
                    ...this.form,
                    event_id: this.GET_EVENT_ID	
                }
                await this.$store.dispatch('urlPost', payload).then(response=>{
                    Swal.fire(response.icon.toUpperCase(),response.message,response.icon);
                    this.$store.commit('NEW_MASTER_DATA', true);
                    this.$store.commit("DIALOG", false);
                })
            } else {
                Swal.fire({
                    text: `Fill Required Fields (${filtered})`,
                    icon: 'warning',
                    allowOutsideClick: false,
                });
            }
        },
        async updateRafflePrize() {
            // if(this.form.event_activity_images.length > 0){
            //     for (let file of this.form.event_activity_images) {
            //         let base64String = await this.fileToBase64(file);
            //         console.log(base64String); // or do whatever you want with the base64 string
            //     }
            // }else{
            //     this.form.event_activity_images = this.fileToBase64(this.form.event_activity_images)
            // }
            let payload = {
                url: "eventActivities",
                id: this.form.id,
                ...this.form,
                event_id: this.GET_EVENT_ID	
            }
            await this.$store.dispatch("urlPut", payload).then((response) => {
				Swal.fire(response.icon.toUpperCase(),response.message,response.icon);
                this.$store.commit('NEW_MASTER_DATA', true)
				this.closeDialog();
			});
        },
        async getActivityData() {
            this.form.id                    = this.GET_DIALOG_VIEW.id;
            this.form.name                  = this.GET_DIALOG_VIEW.name;
            this.form.description           = this.GET_DIALOG_VIEW.description;
            this.form.activity_image        = this.GET_DIALOG_VIEW.activity_image;
            this.form.event_activity_images = this.GET_DIALOG_VIEW.event_activity_images;
        },
        uploadImage(event) {
            let that = this;
			let reader = new FileReader()
			reader.addEventListener('load', () => {
				that.form.activity_image = reader.result
			})
			let file = event.target.files[0];
			let url = reader.readAsDataURL(file);
		},
        uploadedData(data) {
            if (!data) {
                this.form.event_activity_images = null;
            }
            this.form.event_activity_images = data.attachments;
        },
        clearFileUpload(confirm) {
            if (confirm) {
                this.uploadedFiles = null;
            }
            this.uploadedFiles = null;
            this.$refs.fileUpload.reset();
        },
        triggerFileViewerDialog(value){
            if(value){
                this.$store.commit('FILE_VIEWER_DIALOG', value);
                this.$store.commit('FILE_VIEWER', this.form.event_activity_images)
            }
        },
        checkForRules(){
            if(this.$refs.form){
                this.$refs.form.validate()
                return this.valid
            }
        },
    },
    watch: {
        DIALOGS: {
            handler(val) {
                if (!val) {
                    this.initialForm();
                    this.$store.commit('DIALOG_VIEW', {})
                }
            },
        },
    },
};
</script>
<style scoped>
    .modal_title {
        position: sticky;
        top: 0;
        z-index: 10;
        background-color: white;
    }
</style>
